
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_y1yrh_16rxh_189",
  "root": "awsui_root_y1yrh_16rxh_203",
  "series--highlighted": "awsui_series--highlighted_y1yrh_16rxh_215",
  "series--dimmed": "awsui_series--dimmed_y1yrh_16rxh_219",
  "series--threshold": "awsui_series--threshold_y1yrh_16rxh_223",
  "popover-divider": "awsui_popover-divider_y1yrh_16rxh_228"
};
  